(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof gsap === 'undefined') return;
  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  // 1. Hero heading: bean hops P -> t -> l -> lands in the "o" slot, then occasionally rocks side to side
  var heading = document.querySelector('[id$="__hero-banner"] .banner__heading');
  if (heading) {
    var text = heading.textContent.trim();
    heading.setAttribute('aria-label', text);
    heading.style.position = 'relative';
    heading.innerHTML = '';
    var wrap = document.createElement('span');
    wrap.setAttribute('aria-hidden', 'true');

    var letterSpans = [];
    var oIndex = text.indexOf('o');
    text.split('').forEach(function (ch, i) {
      if (ch === ' ') {
        wrap.appendChild(document.createTextNode(' '));
        letterSpans.push(null);
        return;
      }
      var span = document.createElement('span');
      span.style.display = 'inline-block';
      span.textContent = ch;
      if (i === oIndex) {
        span.style.visibility = 'hidden';
      }
      wrap.appendChild(span);
      letterSpans.push(span);
    });
    heading.appendChild(wrap);

    var beanEl = document.createElement('span');
    beanEl.setAttribute('aria-hidden', 'true');
    beanEl.style.cssText =
      'position:absolute;left:0;top:0;width:0.72em;height:0.87em;pointer-events:none;';
    beanEl.innerHTML =
      '<svg viewBox="0 0 100 120" fill="none" style="display:block;width:100%;height:100%">' +
      '<clipPath id="hero-bean-clip"><path d="M49 9 C68 6 85 22 83 47 C87 68 79 96 60 109 C44 119 22 110 16 88 C9 66 13 40 26 22 C33 13 41 11 49 9 Z"/></clipPath>' +
      '<g clip-path="url(#hero-bean-clip)">' +
      '<path d="M50,4 C36,26 62,48 42,72 C32,90 56,102 50,116 L100,120 L100,0 Z" fill="#D9A683"/>' +
      '<path d="M50,4 C36,26 62,48 42,72 C32,90 56,102 50,116 L0,120 L0,0 Z" fill="#ECC6B1"/>' +
      '<path d="M50,4 C36,26 62,48 42,72 C32,90 56,102 50,116" stroke="#103948" stroke-width="2.3" stroke-linecap="round" fill="none"/>' +
      '</g>' +
      '<path d="M52 12 C74 10 88 30 82 52 C90 70 72 104 52 108 C30 114 14 96 15 72 C10 54 20 30 34 18 C40 13 46 13 52 12 Z" stroke="#103948" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    heading.appendChild(beanEl);

    // Center of a letter (used for the final landing spot, the "o" slot).
    function centerFor(span) {
      var headingRect = heading.getBoundingClientRect();
      var elRect = span.getBoundingClientRect();
      var beanRect = beanEl.getBoundingClientRect();
      return {
        x: elRect.left - headingRect.left + elRect.width / 2 - beanRect.width / 2,
        y: elRect.top - headingRect.top + elRect.height / 2 - beanRect.height / 2,
      };
    }

    // Perched on top of a letter, like standing on its head (used for the P / t / l hops).
    function perchFor(span) {
      var headingRect = heading.getBoundingClientRect();
      var elRect = span.getBoundingClientRect();
      var beanRect = beanEl.getBoundingClientRect();
      return {
        x: elRect.left - headingRect.left + elRect.width / 2 - beanRect.width / 2,
        y: elRect.top - headingRect.top - beanRect.height * 0.55,
      };
    }

    function squashLetter(span) {
      if (!span) return;
      gsap.set(span, { transformOrigin: '50% 100%' });
      gsap
        .timeline()
        .to(span, { scaleY: 0.6, scaleX: 1.25, duration: 0.09, ease: 'power2.out' })
        .to(span, { scaleY: 1.08, scaleX: 0.96, duration: 0.14, ease: 'power2.out' })
        .to(span, { scaleY: 1, scaleX: 1, duration: 0.4, ease: 'elastic.out(1, 0.4)' });
    }

    var pIndex = 0;
    var tIndex = text.indexOf('t');
    var lIndex = text.indexOf('l');

    var heroTl = gsap.timeline({ delay: 0.15 });
    heroTl.from(wrap, { opacity: 0, y: 16, duration: 0.6, ease: 'power2.out' });

    var heroSub = document.querySelectorAll(
      '[id$="__hero-banner"] .banner__text, [id$="__hero-banner"] .banner__buttons'
    );
    if (heroSub.length) {
      heroTl.from(
        heroSub,
        { opacity: 0, y: 16, duration: 0.6, ease: 'power2.out', stagger: 0.1 },
        '-=0.35'
      );
    }

    // Wait for layout (and the fade-in) to settle, then measure letter positions and hop across them.
    gsap.delayedCall(0.5, function () {
      var perchP = perchFor(letterSpans[pIndex]);
      var perchT = perchFor(letterSpans[tIndex]);
      var perchL = perchFor(letterSpans[lIndex]);
      var landO = centerFor(letterSpans[oIndex]);
      var hopUp = 38;

      // A single "hop over the top" from A to B: rises well above both perches, then drops down onto B.
      function addHop(tl, from, to, onLandSpan) {
        var peakY = Math.min(from.y, to.y) - hopUp;
        tl.to(beanEl, {
          x: (from.x + to.x) / 2,
          y: peakY,
          duration: 0.24,
          ease: 'power1.out',
        }).to(beanEl, {
          x: to.x,
          y: to.y,
          duration: 0.26,
          ease: 'power1.in',
          onComplete: onLandSpan ? function () { squashLetter(onLandSpan); } : undefined,
        });
      }

      var startPos = { x: perchP.x - 46, y: perchP.y - 30 };
      gsap.set(beanEl, { x: startPos.x, y: startPos.y, opacity: 0, scale: 0.7 });

      var hopTl = gsap.timeline();
      hopTl.to(beanEl, { opacity: 1, scale: 1, duration: 0.2, ease: 'power2.out' });
      // hop 1: onto P
      addHop(hopTl, startPos, perchP, letterSpans[pIndex]);
      hopTl.to({}, { duration: 0.22 }); // brief pause, perched on P
      // hop 2: P -> t
      addHop(hopTl, perchP, perchT, letterSpans[tIndex]);
      hopTl.to({}, { duration: 0.22 }); // brief pause, perched on t
      // hop 3: t -> l
      addHop(hopTl, perchT, perchL, letterSpans[lIndex]);
      hopTl.to({}, { duration: 0.22 }); // brief pause, perched on l
      // final: l -> settle into the "o" slot
      addHop(hopTl, perchL, landO);
      hopTl
        // settle into place
        .to(beanEl, { scale: 1.12, duration: 0.1, ease: 'power1.out' })
        .to(beanEl, { scale: 1, duration: 0.25, ease: 'elastic.out(1, 0.5)' });

      // Occasionally (not continuously) rock left-right twice, then go quiet for a while.
      gsap.set(beanEl, { transformOrigin: '50% 85%' });
      function occasionalWiggle() {
        gsap
          .timeline()
          .to(beanEl, { rotation: 9, duration: 0.14, ease: 'power1.inOut' })
          .to(beanEl, { rotation: -9, duration: 0.28, ease: 'power1.inOut' })
          .to(beanEl, { rotation: 9, duration: 0.28, ease: 'power1.inOut' })
          .to(beanEl, { rotation: 0, duration: 0.14, ease: 'power1.inOut' });
        scheduleWiggle();
      }
      function scheduleWiggle() {
        gsap.delayedCall(5 + Math.random() * 6, occasionalWiggle);
      }
      hopTl.call(scheduleWiggle);

      // Keep the bean pinned to the "o" slot if the layout reflows (resize / orientation change).
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var landed = centerFor(letterSpans[oIndex]);
          gsap.set(beanEl, { x: landed.x, y: landed.y });
        }, 150);
      });
    });
  }

  // 2. Roasting Style cards: tilt + scale reveal on scroll
  if (window.ScrollTrigger) {
    var cards = document.querySelectorAll(
      '[id$="__multicolumn_txNjmj"] .multicolumn-list__item'
    );
    if (cards.length) {
      ScrollTrigger.batch(cards, {
        start: 'top 88%',
        once: true,
        onEnter: function (batch) {
          gsap.from(batch, {
            opacity: 0,
            y: 40,
            rotation: function (i) {
              return i % 2 === 0 ? -6 : 6;
            },
            scale: 0.92,
            duration: 0.7,
            ease: 'back.out(1.4)',
            stagger: 0.12,
          });
        },
      });
    }
  }

  // 3. Product cards: cursor-follow tilt on hover (desktop / fine-pointer only)
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var productCards = document.querySelectorAll(
      '[id$="__featured-collection"] .card-wrapper'
    );
    productCards.forEach(function (card) {
      gsap.set(card, { transformPerspective: 600 });
      var rotX = gsap.quickTo(card, 'rotationX', { duration: 0.4, ease: 'power3' });
      var rotY = gsap.quickTo(card, 'rotationY', { duration: 0.4, ease: 'power3' });
      var lift = gsap.quickTo(card, 'y', { duration: 0.4, ease: 'power3' });

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        rotY(px * 10);
        rotX(py * -10);
        lift(-4);
      });
      card.addEventListener('mouseleave', function () {
        rotX(0);
        rotY(0);
        lift(0);
      });
    });
  }
})();
